import React from 'react';
import { useTranslation } from 'react-i18next';
import { Section, SectionTitle, CheckboxGroup, CheckboxLabel } from '../AdvancedSearchBuilder.styled';

const getSeasonKey = (name) => ({ summer: 'summer', winter: 'winter', 'all season': 'allSeason', 'all-season': 'allSeason' }[name?.toLowerCase()] || name);

const SeasonsSection = ({ seasons, selectedSeasons, onToggle }) => {
  const { t } = useTranslation();
  if (!seasons?.length) return null;
  return (
    <Section>
      <SectionTitle>{t('season')}</SectionTitle>
      <CheckboxGroup>
        {seasons.map((s) => (
          <CheckboxLabel key={s.id} checked={selectedSeasons.includes(s.id)}>
            <input type="checkbox" checked={selectedSeasons.includes(s.id)} onChange={() => onToggle(s.id)} />
            {t(getSeasonKey(s.name))}
          </CheckboxLabel>
        ))}
      </CheckboxGroup>
    </Section>
  );
};

export default SeasonsSection;

